import { useContext } from "react";
import { Switch, theme, Tooltip } from "antd";
import { MoonFilled, SunFilled } from "@ant-design/icons";
import AppContext from "../store/app.context";

export const ThemeToggle = () => {
	const { theme: currentTheme, setTheme } = useContext(AppContext);
	const { token } = theme.useToken();

	const toggleTheme = () => {
		const newTheme = currentTheme === "light" ? "dark" : "light";
		setTheme(newTheme);
	};

	return (
		<Tooltip title={currentTheme === "light" ? "Beralih ke mode gelap" : "Beralih ke mode terang"}>
			{/* <Button
				type="text"
				icon={currentTheme === "light" ? <SunFilled /> : <MoonFilled />}
				onClick={toggleTheme}
				style={{
					color: token.colorText,
					border: "none",
					borderRadius: "50%",
					width: "32px",
					height: "32px",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
				}}
			/> */}
			<Switch
				checked={currentTheme === "dark"}
				onChange={toggleTheme}
				checkedChildren={<MoonFilled style={{ color: token.colorWarning }} />}
				unCheckedChildren={<SunFilled style={{ color: token.colorWarning }} />}
				style={{
					background: currentTheme === "dark" ? token.colorBgContainer : token.colorBgContainer,
					border: `1px solid ${currentTheme === "dark" ? token.colorBorder : token.colorBorder}`,
				}}
			/>
		</Tooltip>
	);
};
